import React from "react";

const categories = [
    {
        title: "Insecticides",
        image:
            "/images/img/insec.jpg",
    },
    {
        title: "Fungicides",
        image:
            "/images/img/fung.jpg",
    },
    {
        title: "Fertilizers",
        image:
            "/images/img/ferti.jpg",
    },
    {
        title: "Herbicides",
        image:
            "/images/img/herb.jpg",
    },
    {
        title: "Plant Growth Regulators",
        image:
            "/images/img/pgr.jpg",
    },
    {
        title: "NPK Fertilizers",
        image:
            "/images/img/npk.jpg",
    },
];

const CategoriesSection = () => {
    return (
        <section className="categories-section">
            <div className="container">

                {/* HEADING */}
                <div className="text-center mb-5">
                    <h6 className="section-subtitle">OUR PRODUCT CATEGORIES</h6>
                    <h2 className="section-title">
                        Complete <span>Agricultural Solutions</span>
                    </h2>
                </div>

                <div className="row">
                    {categories.map((cat, index) => (
                        <div className="col-lg-4 col-md-6 mb-4" key={index}>
                            <div className="category-card">
                                <img src={cat.image} alt={cat.title} />
                                <div className="category-title">
                                    <h4>{cat.title}</h4>
                                </div>
                                <div className="category-overlay">
                                    <h4>{cat.title}</h4>
                                    <a href="/products" className="category-btn">
                                        View Products
                                    </a>
                                </div>
                            </div>

                        </div>
                    ))}
                </div>

            </div>
        </section>
    );
};

export default CategoriesSection;
